import React, { useEffect, useState } from "react";
import "./DashboardHeader.scss";
import { Dropdown } from "react-bootstrap";
import { cLogo } from "assets/images";
import Union from "assets/images/Union.svg";
import {
  Link,
  useLocation,
  useNavigate,
  matchPath,
  NavLink,
} from "react-router-dom";

import { CustomModal } from "components/modals/ModalBox";
import { FaAngleDown, FaUserEdit } from "react-icons/fa";
import { IoLogOutOutline } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
import { bellIcon, handIcon } from "assets/icons";
import { useSelector } from "react-redux";

const ROUTE_ARR = {
  "/employees-list": ["employeesList"],
  "/dashboard": [],
};
const DashboardHeader = () => {
  const navigate = useNavigate();
  const [logoutModal, setLogoutModal] = useState(false);
  const [adminInfo, setAdminInfo] = useState({});

  // fetchStudent Deatil
  const location = useLocation();
  useEffect(() => {
    Object.entries(ROUTE_ARR).forEach(([key, val]) => {
      const match = matchPath(
        {
          path: `${key}/*`,
          exact: false,
          strict: false,
        },
        location.pathname
      );

      // if match then remove all previous keys
      // console.log(match)
      if (match) {
        try {
          let tempVar = {};
          let localData = JSON.parse(localStorage.getItem("admin"));
          val.forEach((item) => {
            tempVar = { ...tempVar, [item]: localData[item] };
          });
          localStorage.setItem("admin", JSON.stringify(tempVar));
        } catch (err) {
          // localStorage.removeItem("admin")
        }
      }
    });
  }, [location]);

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    navigate("/");
  };

  useEffect(() => {
    setAdminInfo(JSON.parse(localStorage.getItem("adminInfo")));
  }, []);

  const personalInfo = useSelector((state) => state.config.personalInfo);

  return (
    <>
      <div className="dashboard_header">
        <div className="container">
          <div className="header_content">
            <div className="txt_profile">
              {/* <p>Welcome Back!</p> */}
              <h4>
                {personalInfo?.data?.name
                  ? personalInfo?.data?.name
                  : adminInfo?.name}{" "}
                {/* <span>
                <img src={handIcon} alt="" />
              </span>  */}
              </h4>
            </div>
            <div className="right_content">
              <Dropdown className={"customDropdown"}>
                {/* <Dropdown.Toggle id="dropdown-basic">
                  <img src={bellIcon} alt="" />
                  <span className="cstm_dots"></span>
                </Dropdown.Toggle> */}
                {/* <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">Coming Soon</Dropdown.Item>
                </Dropdown.Menu> */}
              </Dropdown>
              <Dropdown className={"customDropdown profile_dropdown"}>
                <Dropdown.Toggle id="dropdown-basic">
                  {/* <img src={personalInfo ? personalInfo?.data?.profilePreview ? personalInfo?.data?.profilePreview : personalInfo?.data?.profile : adminInfo.profile} alt="" /> */}
                  <img src="https://ride-chef-dev.s3.ap-south-1.amazonaws.com/Slayrobe_App/assets/app-icon.png"></img>
                  <p>
                    <b>
                      {personalInfo?.data?.name
                        ? personalInfo?.data?.name
                        : adminInfo?.data?.name}
                    </b>{" "}
                    <span>Slayrobe</span>
                  </p>
                  <FaAngleDown />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={"span"}>
                    <NavLink to={`/edit-profile/${adminInfo._id}`}>
                      <FaUserEdit /> Edit Profile
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Item as={"span"}>
                    <NavLink to="/change-password">
                      <FaUserEdit /> Change Password
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={"span"}
                    onClick={() => setLogoutModal(true)}
                  >
                    <MdLogout /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={logoutModal}
        handleClose={() => setLogoutModal(false)}
        className={"logout"}
        cancelText="Cancel"
        confirmText="Logout"
      >
        <div className="logout_content">
          <span className="icon">
            <IoLogOutOutline />
          </span>
          <h5>
            Logging out will end your current session. Please make sure to save
            any unsaved work before proceeding.
          </h5>
        </div>
        <div className={`button_wrap buttonPosition`}>
          <button
            type="button"
            className="button"
            onClick={() => setLogoutModal(false)}
          >
            No
          </button>
          <button type="button" className="button" onClick={logoutHandler}>
            Yes
          </button>
        </div>
      </CustomModal>
    </>
  );
};
export default DashboardHeader;
